module.exports = __webpack_public_path__ + "static/media/mobilepremium.9fde8594.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/mobilepremium.png
// module id = 766
// module chunks = 0